<template>
  <div id="content" class="center-element">
    <div v-if="name === 'MASTEK'" id="logo" class="center-element center-text">
      <img
        src="../assets/mastek_small@2x.png"
        srcset="
          ../assets/mastek_small@1x.png 1x,
          ../assets/mastek_small@2x.png 2x
        "
      />
    </div>
    <div v-else id="logo" class="center-element center-text">
      <img
        src="../assets/machinecore_logo_final@2x.png"
        srcset="
          ../assets/machinecore_logo_final@1x.png 1x,
          ../assets/machinecore_logo_final@2x.png 2x
        "
      />
    </div>
    <p>
      <span class="bold">
        {{ name }}
      </span>
      is a leading provider of advanced analytics technology, specifically aimed
      at website performance improvement. Our technology can provide real-time
      analysis of customer feedback and provide performance alerts and reports
      that immediately lead to revenue and customer satisfaction improvements.
      If you want to put your customer at the center of everything you do, our
      voice of customer application is the most efficient and effective way to
      understand how your customers perceive your products, services and website
      experience. We deliver insights that enable your business to take action
      to increase revenues and deliver higher customer satisfaction ratings.
    </p>
    <p>
      Most businesses who operate a website struggle with the ability to
      identify and prioritize performance improvement actions. Our applications
      unlock the power of customer feedback and transform it into easy to digest
      areas of improvement that can be used to prioritize your site activities.
      <span class="bold">
        {{ name }}
      </span>
      gives you the information and the confidence to know what actions to take
      to improve customer perceptions, willingness to recommend, and website
      conversion.
    </p>
    <div class="about-button center-element">
      <router-link
        to="/console/login"
        tag="button"
        name="addProperty"
        class="button button-300 button-centered"
        >Login</router-link
      >
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "About",
  data() {
    return {
      name: process.env.VUE_APP_FACE
    };
  }
};
</script>
<style scoped>
.buttons div {
  lost-column: 1/1;
}
#logo {
  width: 70%;
  margin: 0 auto;
  padding: 20px;
}
.button-centered {
  margin: 0 auto;
  text-align: center;
  display: block;
}
.about-button {
  width: 100%;
  margin: 0 auto;
  padding: 20px;
}
@media (min-width: 480px) {
  .buttons {
    lost-center: 480px;
  }
  .buttons div {
    lost-column: 1/2;
  }
}
</style>
